import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import { FiArrowLeftCircle, FiArrowRightCircle, FiSend } from 'react-icons/fi';
import { FaRegCommentAlt } from 'react-icons/fa';
import { AiFillLike, AiOutlineAppstoreAdd } from 'react-icons/ai';
import api from '../../services/api';
import Header from '../Includes/Header';
import NavNegociacoes from '../Includes/NavNegociacoes';
import TituloPagina from '../Includes/Titulos';
import Footer from '../Includes/Footer';
import FormData, { getHeaders } from 'form-data';
import trash from '../../assests/trash.png';
import icoAvatar from '../../assests/avatar.png';
import { Trans, withTranslation } from "react-i18next";

import './styles.css';

class NegocioInformacao extends React.Component {

  constructor(props) {
    super(props);
    const tags = JSON.parse(sessionStorage.getItem('TAGS'));
    const cidades = [];
    const users = [];

    var axios = require('axios');

    var config = {
      method: 'GET',
      url: sessionStorage.getItem('BASE_URL')+`/v7/negotiations/${parseInt(props.match.params.id)}`,
      headers: {
        'USER_EMAIL': sessionStorage.getItem('email'),
        'USER_TOKEN': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
    };

    axios(config)
      .then(response => {
        response.data['tags'] = tags;
        response.data['frigorificos'] = [];
        response.data['cidades'] = cidades;
        response.data['users'] = users;
        if (!response.data['age_of_bovine']) {
          response.data['age_of_bovine'] = "zero_to_twelve";
        }
        response.data['bread'] = "";
        if (!response.data.fridge) {
          response.data['fridge_id'] = "";
          response.data['slaughter_house_name'] = "";
          response.data['fridge'] = { 'name': '' }
        } else {
          response.data['fridge_id'] = response.data.fridge.id;
          response.data['slaughter_house_name'] = response.data.fridge.name;
        }
        response.data['reviwer_id'] = (response.data.reviwer !== null) ? response.data.reviwer.id : 1;
        response.data['erros'] = [];
        if (!response.data['bovine_weight']) {
          response.data['bovine_weight'] = "";
        }
        response.data['userEmail'] = sessionStorage.getItem('email');
        response.data['userToken'] = sessionStorage.getItem('token');
        response.data['tag_id'] = response.data.tag.id;
        response.data['nome'] = (response.data.reviwer === null) ? "" : response.data.reviwer.name;
        if (!response.data.slaughter_form) {
          response.data['slaughter_form'] = 'dead_weight';
        }
        if (!response.data.animals_quantity) {
          response.data['animalsQuantity'] = 0;
        }
        if (!response.data.date) {
          var data = new Date();
          response.data['date'] = data.getDate() + '/' + (data.getMonth() + 1) + '/' + data.getFullYear();
        }
        localStorage.setItem('nome', (response.data.reviwer === null) ? '' : response.data.reviwer.name);
        this.setState(response.data);
      }).catch(function (error) {
        console.log(error);
      })




    // api.get(`/v7/negotiations/${parseInt(props.match.params.id)}`, {
    //   headers: {
    //     'USER_EMAIL': sessionStorage.getItem('email'),
    //     'USER_TOKEN': sessionStorage.getItem('token'),
    //     'Content-Type': 'application/json'
    //   }
    // }).then(response => {
    //   response.data['tags'] = tags;
    //   response.data['frigorificos'] = [];
    //   response.data['cidades'] = cidades;
    //   response.data['users'] = users;
    //   if (!response.data['age_of_bovine']) {
    //     response.data['age_of_bovine'] = "zero_to_twelve";
    //   }
    //   response.data['bread'] = "";
    //   if (!response.data.fridge) {
    //     response.data['fridge_id'] = "";
    //     response.data['slaughter_house_name'] = "";
    //     response.data['fridge'] = { 'name': '' }
    //   } else {
    //     response.data['fridge_id'] = response.data.fridge.id;
    //     response.data['slaughter_house_name'] = response.data.fridge.name;
    //   }
    //   response.data['reviwer_id'] = (response.data.reviwer!==null)?response.data.reviwer.id:1;
    //   response.data['erros'] = [];
    //   if (!response.data['bovine_weight']) {
    //     response.data['bovine_weight'] = "";
    //   }
    //   response.data['userEmail'] = sessionStorage.getItem('email');
    //   response.data['userToken'] = sessionStorage.getItem('token');
    //   response.data['tag_id'] = response.data.tag.id;
    //   response.data['nome'] = (response.data.reviwer===null)?"":response.data.reviwer.name;
    //   if (!response.data.slaughter_form) {
    //     response.data['slaughter_form'] = 'dead_weight';
    //   }
    //   if (!response.data.animals_quantity) {
    //     response.data['animalsQuantity'] = 0;
    //   }
    //   if (!response.data.date) {
    //     var data = new Date();
    //     response.data['date'] = data.getDate() + '/' + (data.getMonth() + 1) + '/' + data.getFullYear();
    //   }
    //   localStorage.setItem('nome', (response.data.reviwer===null)?'':response.data.reviwer.name);
    //   this.setState(response.data);
    // });

  }

  componentDidUpdate(prevState, prevProps) {
    // this.carregaTags(this.state.tag.id)
    if (prevState === prevProps) {
      return;
    }
  }

  apagaVetor(contador) {
    let excluir = contador - 1;
    if (excluir < 0) {
      excluir = 0;
    }
    //this.state.slaughters(this.state.slaughters.splice(excluir, 1));
    var slaughters = this.state.slaughters.splice(excluir, 1);

    this.setState({ 'slaughters': slaughters })
    var elemento_pai = document.getElementById('listaAbates');
    elemento_pai.innerHTML = "";
    var titulo = '';
    var textoTitulo = '';
    var cont = 0;
    var qtde = "";
    var textoQtde = "";
    var dtAbate = "";
    var dt = "";
    var textoDtAbate = "";
    var aproveitamento = "";
    var apr = "";
    var txtAprov = "";
    var icone = "";
    this.state.slaughters.forEach(element => {

      if ((cont + 1) === this.state.slaughters.length) {
        icone = document.createElement("p");
        icone.className = "clIcon";
        var image = new Image(25, 25);
        image.src = trash;
        image.alt = cont;
        image.onclick = () => this.apagaVetor(cont);
        icone.appendChild(image);
      } else {
        icone = document.createElement("p");
      }
      titulo = document.createElement('p');
      titulo.className = "tituloAbate";
      textoTitulo = document.createTextNode(this.props.t('pages.negotiationInformation.slaughter') + (cont + 1));
      titulo.appendChild(textoTitulo);

      qtde = document.createElement('p');
      qtde.className = "qtdeAbate";
      textoQtde = document.createTextNode(this.props.t('pages.negotiationInformation.animalsQuantity') + element.animals_quantity);
      qtde.appendChild(textoQtde);

      dtAbate = document.createElement('p');
      dtAbate.className = "qtdeAbate";
      textoDtAbate = document.createTextNode(this.props.t('pages.negotiationInformation.animalsQuantity') + element.slaughter_date.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1'));
      dtAbate.appendChild(textoDtAbate);

      aproveitamento = document.createElement('p');
      aproveitamento.className = "aproveitamento";
      txtAprov = document.createTextNode(this.props.t('pages.negotiationInformation.slaughterDate') + element.slaughter_yield);
      aproveitamento.appendChild(textoDtAbate);
      elemento_pai.appendChild(icone);
      elemento_pai.appendChild(titulo);
      elemento_pai.appendChild(qtde);
      elemento_pai.appendChild(aproveitamento);
      cont++;
    });
    if (this.state.slaughters.length === 0) {
      this.setState({
        'slaughters': []
      });
    }
  }

  addAbate() {
    var animalsQuantity = document.getElementById('animals_quantity').value;
    var slaughter_date = document.getElementById('slaughter_date').value;
    var slaughter_yield = 0;
    if (animalsQuantity && slaughter_date) {
      this.state.slaughters.push({
        'animals_quantity': animalsQuantity,
        'slaughter_date': slaughter_date,
        'slaughter_yield': slaughter_yield,
      });
      var elemento_pai = document.getElementById('listaAbates');
      elemento_pai.innerHTML = "";
      var titulo = '';
      var textoTitulo = '';
      var cont = 0;
      var qtde = "";
      var textoQtde = "";
      var dtAbate = "";
      var dt = "";
      var textoDtAbate = "";
      var aproveitamento = "";
      var apr = "";
      var txtAprov = "";
      var icone = "";

      this.state.slaughters.forEach(element => {
        if ((cont + 1) === this.state.slaughters.length) {
          icone = document.createElement("p");
          icone.className = "clIcon";
          var image = new Image(25, 25);
          image.src = trash;
          image.onclick = () => this.apagaVetor(cont);
          image.alt = cont;
          icone.appendChild(image);
        } else {
          icone = document.createElement("p");
        }

        titulo = document.createElement('p');
        titulo.className = "tituloAbate";
        textoTitulo = document.createTextNode(this.props.t('pages.negotiationInformation.slaughter') + (cont + 1));
        titulo.appendChild(textoTitulo);

        qtde = document.createElement('p');
        qtde.className = "qtdeAbate";
        textoQtde = document.createTextNode(this.props.t('pages.negotiationInformation.animalsQuantity') + element.animals_quantity);
        qtde.appendChild(textoQtde);

        dtAbate = document.createElement('p');
        dtAbate.className = "qtdeAbate";
        textoDtAbate = document.createTextNode(this.props.t('pages.negotiationInformation.animalsQuantity') + element.slaughter_date.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1'));
        dtAbate.appendChild(textoDtAbate);

        aproveitamento = document.createElement('p');
        aproveitamento.className = "aproveitamento";
        txtAprov = document.createTextNode(this.props.t('pages.negotiationInformation.slaughterDate') + element.slaughter_yield);
        aproveitamento.appendChild(textoDtAbate);
        elemento_pai.appendChild(icone);
        elemento_pai.appendChild(titulo);
        elemento_pai.appendChild(qtde);
        elemento_pai.appendChild(aproveitamento);
        cont++;
      });
    }

  }

  carregaAbate() {
    var elemento_pai = document.getElementById('listaAbates');
    elemento_pai.innerHTML = "";
    var titulo = '';
    var textoTitulo = '';
    var cont = 0;
    var qtde = "";
    var textoQtde = "";
    var dtAbate = "";
    var dt = "";
    var textoDtAbate = "";
    var aproveitamento = "";
    var apr = "";
    var txtAprov = "";
    var icone = "";

    this.state.slaughters.forEach(element => {
      if ((cont + 1) === this.state.slaughters.length) {
        icone = document.createElement("p");
        icone.className = "clIcon";
        var image = new Image(25, 25);
        image.src = trash;
        image.onclick = () => this.apagaVetor(cont);
        image.alt = cont;
        icone.appendChild(image);
      } else {
        icone = document.createElement("p");
      }

      titulo = document.createElement('p');
      titulo.className = "tituloAbate";
      textoTitulo = document.createTextNode(this.props.t('pages.negotiationInformation.slaughter') + (cont + 1));
      titulo.appendChild(textoTitulo);

      qtde = document.createElement('p');
      qtde.className = "qtdeAbate";
      textoQtde = document.createTextNode(this.props.t('pages.negotiationInformation.animalsQuantity') + element.animals_quantity);
      qtde.appendChild(textoQtde);

      dtAbate = document.createElement('p');
      dtAbate.className = "qtdeAbate";
      textoDtAbate = document.createTextNode(this.props.t('pages.negotiationInformation.animalsQuantity') + element.slaughter_date.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1'));
      dtAbate.appendChild(textoDtAbate);

      aproveitamento = document.createElement('p');
      aproveitamento.className = "aproveitamento";
      txtAprov = document.createTextNode(this.props.t('pages.negotiationInformation.slaughterDate') + element.slaughter_yield);
      aproveitamento.appendChild(textoDtAbate);
      elemento_pai.appendChild(icone);
      elemento_pai.appendChild(titulo);
      elemento_pai.appendChild(qtde);
      elemento_pai.appendChild(aproveitamento);
      cont++;
    });
  }

  handleInputChangeKind(event) {
    this.setState({
      'kind': event
    })
  }

  handleInputSlaughter_form(event) {
    this.setState({
      'slaughter_form': event
    })
  }

  handleInputData(e) {
    var data = new Date();
    var hora = data.getHours();          // 0-23
    var min = data.getMinutes();        // 0-59
    var seg = data.getSeconds();        // 0-59
    var str_hora = hora + ':' + min + ':' + seg;
    this.setState({
      'negotiation_date': e.value + 'T' + str_hora + ':00.000-03:00'
    })
    return e.value;
  }

  pegarInputData() {
    return this.state.negotiation_date;
  }

  abreTags(e) {
    this.setState({
      'tag': {
        'id': (e.target.value)
      }
    });
    this.setState({
      'tag_id': e.target.value
    })
    this.state.tags.forEach(tag => {
      let i = 0;
      if (parseInt(tag.id) === parseInt(e.target.value)) {
        const isBovine = document.querySelectorAll(".is_bovine");
        if (tag.is_bovine === true) {
          for (i = 0; i < isBovine.length; i++) {
            isBovine.item(i).classList.remove('hidden');
          }
          const isSlaughter = document.querySelectorAll(".is_slaughter");
          if (tag.is_slaughter === false) {
            //setAge_of_bovine('zero_to_twelve');
            for (i = 0; i < isSlaughter.length; i++) {
              isSlaughter.item(i).classList.remove('hidden');
            }
            for (i = 0; i < isBovine.length; i++) {
              isBovine.item(i).classList.add('hidden');
            }
          } else {
            for (i = 0; i < isSlaughter.length; i++) {
              isSlaughter.item(i).classList.add('hidden');
            }
          }
        } else {
          for (i = 0; i < isBovine.length; i++) {
            isBovine.item(i).classList.add('hidden');
          }
        }
      }
    });
  }

  async SelectFrigorifico(frig) {
    if (frig.length >= 3) {
      await api.get(`/v5/fridges/optimized_index?by_name=${frig}`, {
        headers: {
          'USER_EMAIL': sessionStorage.getItem('email'),
          'USER_TOKEN': sessionStorage.getItem('token'),
        }
      }).then(response => {
        var vFrig = response.data;
        this.setState({
          'frigorificos': vFrig
        });
        document.getElementById("dvFrigorificos").style.display = "block";
      }).catch(function (response) {
      });
    }
  }

  meuFrig(nome, id) {
    this.setState({
      'slaughter_house_name': nome,
      'fridge_id': id,
    })
    this.setState({
      'fridge': { 'name': nome }
    });
    //response.data['slaughter_house_name'] = response.data.fridge.name;

    // this.setState({
    //   'fridge': {
    //     'id': id,
    //     'name': nome
    //   }
    // })
    document.getElementById("dvFrigorificos").style.display = "none";
    document.getElementById("frigorifico").value = nome;
  }

  handleSelectPayment_measure(e) {
    this.setState({
      'payment_measure': e
    })
  }

  handlePayment_deadline(e) {
    var diasPag = document.getElementById('diasPag');
    if (e === "vista") {
      diasPag.value = 0;
      diasPag.style.display = 'none';
      this.setState({
        'payment_deadline': 0
      })
    } else {
      diasPag.style.display = 'block';
    }
  }

  handlePayment_deadlineValor(e) {
    this.setState({
      'payment_deadline': e
    })
  }

  carregaPayment_deadline() {
    var pay = document.getElementById('nroDias');
    var diasPag = document.getElementById('diasPag');
    var vista = document.getElementById('vista');
    var prazo = document.getElementById('prazo');
    if (this.state.payment_deadline > 0) {
      diasPag.style.display = 'block';
      pay.value = this.state.payment_deadline;
      prazo.checked = true;
    } else {
      diasPag.style.display = 'none';
      pay.value = "0";
      vista.checked = true;
    }
  }
  carregaTaxForm() {
    var toCharge = document.getElementById('to_charge');
    var free = document.getElementById('free');
    var free_taxes = document.getElementById('free_taxes');
    var tax_form = this.state.tax_form;
    if (tax_form === 'to_charge') {
      toCharge.checked = 'true';
    } else if (tax_form === 'free') {
      free.checked = 'true';
    } else {
      free_taxes.checked = 'true';
    }
  }

  carregaFreight_responsibility() {
    var buyer = document.getElementById('buyer');
    var seller = document.getElementById('seller');
    if (this.state.freight_responsibility === 'buyer') {
      buyer.checked = 'true';
    } else {
      seller.checked = 'true';
    }
  }

  atualizaTagId(id) {
    this.setState({
      'tag_id': id
    })
  }

  carregaTags() {
    this.state.tags.forEach(tag => {
      let i = 0;
      if (parseInt(tag.id) === this.state.tag.id) {
        //this.atualizaTagId(tag.id);
        const isBovine = document.querySelectorAll(".is_bovine");
        if (tag.is_bovine === true) {
          for (i = 0; i < isBovine.length; i++) {
            isBovine.item(i).classList.remove('hidden');
          }
          const isSlaughter = document.querySelectorAll(".is_slaughter");
          if (tag.is_slaughter === false) {
            //setAge_of_bovine('zero_to_twelve');
            for (i = 0; i < isSlaughter.length; i++) {
              isSlaughter.item(i).classList.remove('hidden');
            }
            for (i = 0; i < isBovine.length; i++) {
              isBovine.item(i).classList.add('hidden');
            }
          } else {
            for (i = 0; i < isSlaughter.length; i++) {
              isSlaughter.item(i).classList.add('hidden');
            }
          }
        } else {
          for (i = 0; i < isBovine.length; i++) {
            isBovine.item(i).classList.add('hidden');
          }
        }
      }
    });
  }

  handleTax_form(e) {
    this.setState({
      'tax_form': e
    })
  }

  handleFreight_responsibility(e) {
    var buyer = document.getElementById('buyer');
    var seller = document.getElementById('seller');

    this.setState({
      'freight_responsibility': e
    })
    if (e === 'buyer') {
      buyer.checked = 'true';
    } else {
      seller.checked = 'true';
    }
  }

  handleSelectAge_of_bovine(e) {
    this.setState({
      'age_of_bovine': e
    })
  }

  minhaRevisao(id, nome) {
    this.setState({
      'reviwer_id': id
    })
    document.getElementById("dvCidades").style.display = "none";
    document.getElementById("user").value = nome;
  }

  async SelectUsuario(e) {
    var nome = e.target.value;
    if (nome.length >= 3) {
      await api.get(`/v5/users/reviwers?name=${nome}`, {
        headers: {
          'USER_EMAIL': sessionStorage.getItem('email'),
          'USER_TOKEN': sessionStorage.getItem('token'),
        }
      }).then(response => {
        var dados = response.data;
        this.setState({
          'users': dados
        });
        document.getElementById("dvCidades").style.display = "block";
      }).catch(function (response) {
      });
    }
    document.getElementById("user").value = nome;
  }

  handleNote(e) {
    this.setState({
      'notes': e
    })
  }

  mostrarSuccess() {
    let msg = document.getElementById('success');
    msg.style.display = 'block';
    let btn = document.getElementById('btn-enviar');
    btn.disabled = true;

    setTimeout(() => {
      msg.style.display = 'none';
      //history.push('/negociacoes')
    }, 10000)
  }
  mostrarErros() {
    let msg = document.getElementById('msg');
    msg.style.display = 'block';
    setTimeout(() => {
      msg.style.display = 'none';
    }, 5000)
  }


  alterarInformacaoNegocio(event, dados) {

    event.preventDefault();
    const data = {
      kind: dados.kind,
      slaughter_form: dados.slaughter_form,
      tax_form: dados.tax_form,
      payment_form: "in_installment",
      freight_responsibility: dados.freight_responsibility,
      date: dados.date,
      bread: dados.bread,
      bovine_weigth: dados.bovine_weigth,
      negotiated_value: dados.negotiated_value,
      tag_id: dados.tag_id,
      user_id: dados.user.id,
      created_at: dados.negotiation_date,
      updated_at: dados.negotiation_date,
      payment_deadline: (dados.payment_deadline === null) ? 0 : dados.payment_deadline,
      slaughter_house_name: dados.slaughter_house_name,
      payment_measure: dados.payment_measure,
      city_code: dados.city.code,
      age_of_bovine: dados.age_of_bovine,
      negotiation_date: dados.negotiation_date,
      animals_quantity: dados.animals_quantity,
      fridge_id: dados.fridge_id,
      notes: dados.notes,
      slaughters: dados.slaughters,
      reviwer_id: dados.reviwer_id,
      reviwer: dados.reviwer,
    }

    var axios = require('axios');
    var config = {
      method: 'put',
      url: sessionStorage.getItem('BASE_URL') + `/v4/users/me/negotiations/${dados.id}`,
      headers: {
        'USER_TOKEN': dados.userToken,
        'USER_EMAIL': dados.userEmail,
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        //this.mostrarSuccess();
        let msg = document.getElementById('success');
        msg.style.display = 'block';
        let btn = document.getElementById('btn-enviar');
        btn.disabled = true;
        setTimeout(() => {
          msg.style.display = 'none';
          window.location = "/?negociacoes";
        }, 7000);
        dados['erros'] = [];
      }).catch(function (error) {
        //setErros(error.response.data.errors);
        if (!error.response.data.errors) {
          dados['erros'] = []
        } else {
          dados['erros'] = error.response.data.errors;
        }
        // MOSTRAR ERROS
        let msg = document.getElementById('msg');
        msg.style.display = 'block';
        setTimeout(() => {
          msg.style.display = 'none';
        }, 5000)
        // MOSTRAR ERROS

      });
  };

  desativarForm(event) {
    event.preventDefault();
  }

  handleNegotiated_value(e) {
    this.setState({
      'negotiated_value': e
    })
  }

  show() {
    const y = document.getElementById('diasPag')
    y.style.display = 'block'
  }

  handleBread(e) {
    this.setState({
      'bread': e
    })
  }

  handleBovine_weight(e) {
    this.setState({
      'bovine_weight': e
    })
  }

  handleAnimals_quantity(e) {
    this.setState({
      'animals_quantity': e
    })
  }

  render() {
    if (!this.state) {
      return (
        <div className="negocio-container">
          <div className="negocio-container">
            <Header />
            <NavNegociacoes />
            <TituloPagina titulo={ this.props.t('pages.negotiationInformation.title') } />
            <section className="body">
              <ul>
                <li>
                  <div className="clCarregando"> { this.props.t('pages.negotiationInformation.loading') } </div>
                </li>
              </ul>
            </section>
          </div>
          <Footer />
        </div>

      );
    } else {
      return (
        <div className="negocio-informacao-container">
          <Header />
          <NavNegociacoes />
          <TituloPagina titulo={ this.props.t('pages.negotiationInformation.title') } />
          <section className="body">
            <ul>
              <li>
                <form className="formNegocio" onSubmit={e => this.alterarInformacaoNegocio(e, this.state)}>
                  <div className="info">
                  <Trans components={{ pInit: <p> , pEnd: </p> }}>
                    { this.props.t('pages.negotiationInformation.info') }
                  </Trans>
                  </div>
                  <div className="titulo">
                    { this.props.t('pages.negotiationInformation.sendTo') }
                  </div>
                  <div className="campos">
                    <input
                      value=""
                      onChange=""
                      id="city_id"
                      className="city_id"
                      name="city_id"
                      type="hidden"
                    />
                    <input
                      //placeholder="user"
                      onKeyUp={e => this.SelectUsuario(e)}
                      type="text" name="user" id="user"
                      // value={localStorage.getItem('nome')}
                      autocomplete="off"
                      defaultValue={localStorage.getItem('nome')}
                    />
                  </div>
                  <div className="cidades" id="dvCidades">
                    {
                      this.state.users.map(user => (
                        <div className="linhaUsuarios">
                          <Link onClick={() => this.minhaRevisao(user.id, user.name)}><img src={(user.avatar.mini_thumb !== null) ? user.avatar.mini_thumb : icoAvatar} alt="ico" />{user.name}</Link>
                        </div>
                      ))
                    }
                  </div>

                  <div className="success" id="success">
                    <p><strong> { this.props.t('pages.negotiationInformation.messages.success') } </strong></p>
                  </div>
                  <div className="alert" id="msg">
                    <p><strong> { this.props.t('pages.negotiationInformation.messages.invalidData') } </strong></p>
                    {this.state.erros.map(err => (
                      <p>- {err}</p>
                    ))}
                  </div>
                  <div id="log">

                  </div>
                  <div className="campos">
                    <button className="btn-enviar" id="btn-enviar" type="submit"> { this.props.t('pages.negotiationInformation.buttons.send') } </button>
                  </div>
                </form>
              </li>
            </ul>
          </section>
          <Footer />
        </div>
      )
    }
  }
}

export default withTranslation()(NegocioInformacao);